import { axiosInstance } from "..";

export const TrainingContentService = {
  get: () => {
    return axiosInstance.get("/content/trainings");
  },
};
